import React from "react";
import formImage from "../assets/dukaanframe.jpg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import CustomField from "../components/common/customField";
import { optionsForBusinessCategory } from "../components/common/utlity/options";

const validationSchema = Yup.object({
  businessName: Yup.string().required("Business Name is required"),
  businessCategory: Yup.string().required("Business Category is required"),
  // pincode: Yup.string()
  //   .required("Pincode is required")
  //   .matches(/^\d{6}$/, "Pincode must be a 6-digit number"),
  // acceptTerms: Yup.boolean().oneOf(
  //   [true],
  //   "You must accept the terms and conditions"
  // ),
});
const initialValues = {
  businessName: "",
  businessCategory: "no_select",
  pincode: "",
  acceptTerms: false,
};
const RegistrationForm = () => {
  const onSubmit = (values) => {
    console.log("Form Data:", values);
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formik) => {
        const { values, handleChange, setFieldValue, errors } = formik;
        console.log("values is here", values);
        console.log("errors is here", errors);

        return (
          <Form>
            <div className='bg-white-500 flex h-screen'>
              <div className='hidden sm:block' style={{ width: "662px" }}>
                <img
                  className='w-full h-full object-cover'
                  src={formImage}
                  alt='Form visual'
                />
              </div>

              <div className='bg-white-100 p-8 rounded-lg'>
                <h2 className='text-center mt-5 text-blue-800 font-bold text-3xl'>
                  Enter your Details
                </h2>
                <h3 className='font-medium text-1 text-gray-700'>
                  Please Enter your Details
                </h3>

                {/* Business Name Field */}
                {/* <div className='text-left text-1 text-gray-700 font-small text-s mb-4'> */}
                <div className='grid grid-cols-2 gap-4'>
                  {/* <label htmlFor='businessName'>Business Name*</label> */}
                  {/* <div>
                    <Field
                      id='businessName'
                      className='w-full p-2 border-solid border-2 border-black-600'
                      type='text'
                      name='businessName'
                      placeholder='Enter your business name'
                    />
                    <ErrorMessage
                      name='businessName'
                      component='p'
                      className='text-red-500 font-small'
                    />
                  </div> */}
                  {/* <div>
                    <CustomField
                      type='text'
                      name='businessName'
                      label='Business Name *'
                      placeholder='Business Name *'
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      value={values.businessName}
                      error={errors.businessName}
                      touched={touched.businessName}
                    />
                  </div> */}
                  <div>
                    <CustomField
                      type='select'
                      name='businessCategory'
                      label='Business Category *'
                      placeholder='Business Category'
                      options={optionsForBusinessCategory}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      value={values.businessCategory}
                    />
                  </div>
                </div>

                {/* Business Category Field */}
                {/* <div className='text-left text-1 text-gray-700 font-small text-s mb-4'>
                  <label htmlFor='businessCategory'>Business Category*</label>
                  <div>
                    <Field
                      as='select'
                      id='businessCategory'
                      className='w-full p-2 border-solid border-2 border-black-600'
                      name='businessCategory'
                    >
                      <option value='' label='Select your business category' />
                      <option value='Clothing' label='Clothing' />
                      <option value='Medicine' label='Medicine' />
                      <option value='Grocery' label='Grocery' />
                      <option value='Salon' label='Salon' />
                      <option value='Gym' label='Gym' />
                      <option value='Restaurant' label='Restaurant' />
                      <option value='Other' label='Other' />
                    </Field>
                    <ErrorMessage
                      name='businessCategory'
                      component='p'
                      className='text-red-500 font-small'
                    />
                  </div>
                </div> */}

                {/* Pincode Field */}
                {/* <div className='text-left text-1 text-gray-700 font-small text-l mb-4'>
                  <label htmlFor='pincode'>Pincode*</label>
                  <div>
                    <Field
                      id='pincode'
                      className='w-full p-2 border-solid border-2 border-black-600'
                      type='text'
                      name='pincode'
                      placeholder='Enter your pincode'
                      onBlur={handleBlur}
                    />
                    <ErrorMessage
                      name='pincode'
                      component='p'
                      className='text-red-500 font-small'
                    />
                  </div>
                </div> */}

                {/* Terms and Conditions Checkbox */}
                <div className='text-left text-1 text-gray-700 font-small text-l mb-4'>
                  <label>
                    <Field
                      type='checkbox'
                      name='acceptTerms'
                      onChange={handleChange}
                      checked={values.acceptTerms}
                    />
                    &nbsp;
                    <span className='text-black'>I accept all</span>
                    <span className='text-blue-500 underline'>
                      {" "}
                      Terms & Conditions*
                    </span>
                  </label>
                  <ErrorMessage
                    name='acceptTerms'
                    component='p'
                    className='text-red-500 font-small'
                  />
                </div>

                {/* Submit Button */}
                <button
                  type='submit'
                  className='w-full py-2 bg-blue-600 shadow-lg shadow-blue-500/50 hover:shadow-blue-900/40'
                >
                  Save & Next
                </button>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default RegistrationForm;
